import { createSelector } from 'reselect';
export const selectTagsState = createSelector((state) => state.tags, tags => tags);
export const selectTags = createSelector(selectTagsState, tags => tags.list);
export const selectActiveTag = createSelector(selectTags, tags => tags.find((tag) => tag.active));
